<template>
  <div style="padding: 10px;">
    <a-table
      :columns="columnsList"
      :data-source="workLeaves"
      :loading="loading"
      rowKey="id"
      style="margin-top: 10px;"
      size="small"
      :pagination="{
        current: currentPage,
        onChange: (page) => {
          this.currentPage = page;
        },
      }"
    >
      <div slot="footer">
        <a-button
          :loading="loading"
          type="link"
          @click="onPagination"
          :disabled="!isPagination"
        >
          <a-icon type="reload" /> Load more
        </a-button>
      </div>
      <div slot="stt" slot-scope="text, record, index">
        {{ +index + 1 }}
      </div>
      <div slot="typeWorkLeave" slot-scope="text, record">
        <a @click="goTo(record)"> {{ text && text.title }} </a>
      </div>
      <div slot="TrangThai" slot-scope="text">
        <StatusWorkLeave :status="text" />
      </div>
      <div slot="employee" slot-scope="text">
        {{ text && text.fullname }}
      </div>
      <div slot="benefit" slot-scope="text">
        {{ text && text.benefit ? codeBenefit2Title(text.benefit) : "" }}
      </div>
      <div slot="totalLeaveDays" slot-scope="text">
        {{ text | numParseFloat(2) }}
      </div>
      <div slot="createdAt" slot-scope="text">
        {{ text | formatDate }}
      </div>
      <div slot="action" slot-scope="text, record">
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="2" @click="goTo(record)">
              Detail
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px;">
            Options <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <!-- <a-button type="link" @click="collapseModalEdit(record)"> -->
      </div>
    </a-table>
  </div>
</template>
<script>
import { columnsList } from "./constant/column";
import query from "./constant/query";
import codeBenefit2Title from "@/constants/services/codeBenefit2Title";
import StatusWorkLeave from "./components/statusWorkLeave";
const startPage = 1;
const limit = 10;
export default {
  props: {},
  components: { StatusWorkLeave },
  data() {
    return {
      columnsList,
      loading: false,
      workLeaves: [],
      currentPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    codeBenefit2Title,
    getListData(flag) {
      this.loading = true;
      const { idEmployee } = this.$route.params;
      if (!idEmployee) {
        throw new Error("Cannot get id employee");
      }
      this.$apollo
        .query({
          query: query.getAllWorkLeave,
          fetchPolicy: "no-cache",
          variables: {
            employeeId: idEmployee,
            status: "APPROVED",
            page: this.currentPage,
            limit,
          },
        })
        .then(({ data }) => {
          if (data?.getAllWorkLeave?.length >= 0) {
            if (flag === "PAGINATION") {
              this.workLeaves = this.workLeaves.concat([
                ...data.getAllWorkLeave,
              ]);
            } else {
              this.workLeaves = this.workLeaves.concat([
                ...data.getAllWorkLeave,
              ]);
            }

            // check is pagniation
            if (data.getAllWorkLeave.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error("Không lấy được danh sách work leave", err);
        });
    },
    goToDetail(idWorkLeave) {
      this.$router.push({
        name: "Chi tiết nghỉ phép",
        params: { idWorkLeave },
      });
    },
    goToView(idWorkLeave) {
      this.$router.push({ name: "Xem nghỉ phép", params: { idWorkLeave } });
    },
    goTo(item) {
      if (item?.status === "DRAFT") {
        this.goToDetail(item.id);
      } else this.goToView(item.id);
    },
    onPagination() {
      if (this.isPagination) {
        this.currentPage += 1;
        this.getListData("PAGINATION");
      }
    },
  },
  created() {
    this.getListData();
  },
};
</script>
<style lang="css" scoped></style>
